import { cloneDeep } from 'lodash';

const constructDependancyErrors = (args) => {
  const { dependancyObj, dependantRole, errors } = args;
  const updatedErrors = cloneDeep(errors);
  const dependancyErrorIndex = errors.findIndex(
    (el) => el.name === dependantRole.feature.key
  );
  if (dependancyErrorIndex === -1) {
    const errorObject = {
      name: dependantRole.feature.key,
      errors: [dependancyObj.label]
    };
    updatedErrors.push(errorObject);
  } else {
    updatedErrors[dependancyErrorIndex] = {
      ...updatedErrors[dependancyErrorIndex],
      errors: updatedErrors[dependancyErrorIndex].errors.concat([
        dependancyObj.label
      ])
    };
  }
  return updatedErrors;
};

const constructErrorObject = (args) => {
  const { dependancyObj, dependantRole, errors } = args;
  return {
    name: dependantRole.feature.permissionCategory.name,
    errors: constructDependancyErrors({
      errors: [],
      dependancyObj,
      dependantRole
    })
  };
};

/**
 * This method constructs the error response in the following format
 * {
    "name": "MSP Settings",
    "errors": [
        {
            "name": "role",
            "errors": [
                "Employees", "User"
            ]
        },
        {
            "name": "technicianGroup",
            "errors": [
                "Employees", "slaPolicy", "ticketViews"
            ]
        }
    ]
}
 * This format is designed so that it's easy to spot in which section the error is present
 * and also in which role the error is present and for which parent roles, the error is dependant.
 * @param {*} args 
 * @returns {array}
 */

const constructErrorResponse = (args) => {
  const { dependantRole, dependancyObj, errorResponse } = args;
  const updatedErrorResponse = cloneDeep(errorResponse);
  const errorSectionIndex = updatedErrorResponse.findIndex(
    (el) => el.name === dependantRole.feature.permissionCategory.name
  );
  if (errorSectionIndex === -1) {
    const errorObject = constructErrorObject({
      dependancyObj,
      dependantRole,
      errors: []
    });
    updatedErrorResponse.push(errorObject);
  } else {
    updatedErrorResponse[errorSectionIndex] = {
      ...updatedErrorResponse[errorSectionIndex],
      errors: constructDependancyErrors({
        errors: updatedErrorResponse[errorSectionIndex].errors,
        dependantRole,
        dependancyObj
      })
    };
  }
  return updatedErrorResponse;
};

export { constructErrorResponse };
